import {ofType, Epic} from 'redux-observable';
import {concat, EMPTY, iif, of} from 'rxjs';
import {ajax, AjaxError} from 'rxjs/ajax';
import {catchError, mergeMap, filter, timeout} from 'rxjs/operators';
import {AnyAction} from 'redux';
import {ADD_ALERT_ACTION} from '../../common/actions/AlertActions';
import {ERROR_GENERAL_ACTION} from '../actions/UIActions';
import * as ModalActions from '../actions/ModalActions';
import {flattenArray} from '../../common/utils/StringUtils';
import {GLOBAL} from '../constants/LabelConstants';
import {MODAL_TYPE} from '../constants/ModalConstants';
import {ENVIRONMENT} from '../constants/EnvironmentConstants';
import * as MC from '../constants/MotorcreditConstants';
import {VERSION} from '../../common/constants/VersionConstants';
import {State} from '../types/mx/reducers';

export const alertMessage: Epic<AnyAction, any, State> = action$ =>
    action$.pipe(ofType(ERROR_GENERAL_ACTION.name),
        filter(action => !action.retryAction),
        mergeMap(action =>
            iif(
                () => action.payload && Array.isArray(action.payload),
                of(ADD_ALERT_ACTION.action(flattenArray(action.payload)[0])),
                of(ADD_ALERT_ACTION.action(GLOBAL.SERVER_ERROR_MESSAGE))
            )
        )
    );

export const retryApiModal = action$ =>
    action$.pipe(
        ofType(ERROR_GENERAL_ACTION.name),
        filter((action: AnyAction) => action.retryAction),
        mergeMap((action: AnyAction) => {
            const content = {
                type: MODAL_TYPE.ERROR_WITH_RETRY_VIEW
            };
            const footer = {
                acceptBtn: GLOBAL.RETRY,
                retryAction: action.retryAction,
                align: 'center'
            };
            const options = {
                closeOnOverlayClick: true
            };
            return concat(
                of(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, footer, options)),
                iif(
                    () => action.retryAction,
                    ajax(
                        {
                            url: MC.SLACK_WEBHOOK_URL,
                            method: 'POST',
                            body: JSON.stringify({
                                text: `Failure with api call in *${ENVIRONMENT}* environment`,
                                attachments: [{
                                    color: '#FF0000',
                                    // tslint:disable-next-line:max-line-length
                                    text: `\`\`\`{\n\t"ACTION":${getFilteredActionStringified(action.retryAction)},\n\t"URL":"${action.url}",\n\t"METHOD":"${action.method}",\n\t"BODY":${JSON.stringify(action.body)},\n\t"USER-AGENT":"${navigator.userAgent}",\n\t"ERROR":${getFilteredApiErrorStringified(action.apiError)}\n}\`\`\``,
                                    footer: `motorfy-web - wizard (v${VERSION})`,
                                    ts: Date.now() / 1000,
                                    footer_icon:
                                        'https://www.motorfy.com/wp-content/themes/motorcredit/images/favicon.ico'
                                }]
                            }),
                            crossDomain: true
                        }
                    ).pipe(
                        timeout(MC.TIMEOUT),
                        mergeMap(res => EMPTY),
                        catchError(error => EMPTY)
                    ),
                    EMPTY
                )
            );
        }
    ));

const getFilteredActionStringified = action =>
    JSON.stringify({
        ...action,
        ...('accessToken' in action ?
            {accessToken: `${action.accessToken.substring(0, 100)}...${action.accessToken.slice(-100)}`} : {}),
        ...('refreshToken' in action ?
            {refreshToken: `${action.refreshToken.substring(0, 100)}...${action.refreshToken.slice(-100)}`} : {})
    });

/* tslint:disable:max-line-length */
const getFilteredApiErrorStringified = (apiError) => {
    if (Array.isArray(apiError)) {
        const res = [];
        for (const i of apiError) {
            if (i instanceof AjaxError && i.request.headers) {
                res.push({
                    ...i,
                    request: {
                        ...i.request,
                        headers: {
                            ...i.request.headers,
                            ...('access-token' in i.request.headers ?
                                {'access-token': `${(i.request.headers as any)['access-token'].substring(0, 100)}...${(i.request.headers as any)['access-token'].slice(-100)}`} : {}),
                            ...('refresh-token' in i.request.headers ?
                                {'refresh-token': `${(i.request.headers as any)['refresh-token'].substring(0, 100)}...${(i.request.headers as any)['refresh-token'].slice(-100)}`} : {}),
                            ...('Authorization' in i.request.headers ?
                                {Authorization: `${(i.request.headers as any).Authorization.substring(0, 100)}...${(i.request.headers as any).Authorization.slice(-100)}`} : {})
                        }
                    }
                });
            } else {
                res.push(i);
            }
        }
        return JSON.stringify(res);
    }
    return JSON.stringify(apiError);
};
/* tslint:enable:max-line-length */
